import { api } from "./client";

export interface MarketRow {
  symbol: string;
  base_asset: string;
  quote_asset: string;
  display_name: string;
  category: string;
  last: number;
  change_24h_pct: number;
  volume_24h: number;
}

export interface Ticker {
  symbol: string;
  last: number;
  bid: number;
  ask: number;
  change_24h_pct: number;
  volume_24h: number;
  high_24h: number;
  low_24h: number;
  ts: number;
}

export interface Candle {
  t: number;
  o: number;
  h: number;
  l: number;
  c: number;
  v: number;
}

export interface OrderbookSnapshot {
  symbol: string;
  ts: number;
  bids: [number, number][];
  asks: [number, number][];
}

export interface Trade {
  id: string;
  symbol: string;
  side: "buy" | "sell";
  price: number;
  qty: number;
  ts: number;
}

export interface RiskSnapshot {
  symbol: string;
  liquidation_pressure: number;
  volatility_regime: number;
  spread_anomaly: number;
  exchange_divergence: number;
  confidence: "low" | "medium" | "high";
  explanation: string;
  generated_at: number;
}

export const listMarkets = () => api<MarketRow[]>("/v1/markets", { auth: false });

export const getMarket = (symbol: string) =>
  api<MarketRow & { ticker: Ticker }>(`/v1/markets/${encodeURIComponent(symbol)}`, { auth: false });

export const getCandles = (symbol: string, interval = "1m", limit = 200) =>
  api<{ symbol: string; interval: string; candles: Candle[] }>(
    `/v1/markets/${encodeURIComponent(symbol)}/candles?interval=${interval}&limit=${limit}`,
    { auth: false },
  );

export const getOrderbook = (symbol: string, depth = 20) =>
  api<OrderbookSnapshot>(`/v1/markets/${encodeURIComponent(symbol)}/orderbook?depth=${depth}`, {
    auth: false,
  });

export const getTrades = (symbol: string, limit = 50) =>
  api<{ symbol: string; trades: Trade[] }>(
    `/v1/markets/${encodeURIComponent(symbol)}/trades?limit=${limit}`,
    { auth: false },
  );

export const getRisk = (symbol: string) =>
  api<RiskSnapshot>(`/v1/markets/${encodeURIComponent(symbol)}/risk`, { auth: false });

export const getTopMovers = () => api<Ticker[]>("/v1/markets/top-movers", { auth: false });
export const getLiquidationHeat = () => api<RiskSnapshot[]>("/v1/markets/liquidation-heat", { auth: false });
